import React from 'react'
import { UilAngleLeft, UilAngleRight, UilAngleDoubleLeft, UilAngleDoubleRight } from '@iconscout/react-unicons'

class LearnPagination extends React.Component {
  getPaginationRange = () => {
    const { currentPage, totalPages } = this.props
    const delta = 2 // Number of pages to show around current page
    
    // If total pages is small, show all
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }
    
    const range = []
    const left = Math.max(2, currentPage - delta)
    const right = Math.min(totalPages - 1, currentPage + delta)
    
    // Always show first page
    range.push(1)
    
    // Add ellipsis after first page if needed
    if (left > 2) {
      range.push('...')
    }
    
    // Add pages around current page
    for (let i = left; i <= right; i++) {
      if (i !== 1 && i !== totalPages) {
        range.push(i)
      }
    }
    
    // Add ellipsis before last page if needed
    if (right < totalPages - 1) {
      range.push('...')
    }
    
    // Always show last page (if totalPages > 1)
    if (totalPages > 1) {
      range.push(totalPages)
    }
    
    return range
  }

  render() {
    const { 
      currentPage, 
      totalPages, 
      total, 
      perPage,
      onPageChange,
      onFirstPage,
      onPreviousPage,
      onNextPage,
      onLastPage
    } = this.props

    const paginationRange = this.getPaginationRange()
    const startItem = ((currentPage - 1) * perPage) + 1
    const endItem = Math.min(currentPage * perPage, total)

    return (
      <div className="learn-pagination">
        <span>
          <b>{startItem} - {endItem}</b> of {total}
        </span>
        <div className="pagination-buttons">
          <button 
            disabled={currentPage === 1} 
            onClick={onFirstPage}
          >
            <UilAngleDoubleLeft size="21" />
            <span className="button-text">First</span>
          </button>
          <button 
            disabled={currentPage === 1} 
            onClick={onPreviousPage}
          >
            <UilAngleLeft size="21" />
            <span className="button-text">Previous</span>
          </button>
          
          {paginationRange.map((page, index) => {
            if (page === '...') {
              return (
                <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                  ...
                </span>
              )
            }
            
            return (
              <button 
                key={page}
                className={currentPage === page ? 'active' : ''}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            )
          })}
          
          <button 
            disabled={currentPage === totalPages} 
            onClick={onNextPage}
          >
            <span className="button-text">Next</span>
            <UilAngleRight size="21" />
          </button>
          <button 
            disabled={currentPage === totalPages} 
            onClick={onLastPage}
          >
            <span className="button-text">Last</span>
            <UilAngleDoubleRight size="21" />
          </button>
        </div>
      </div>
    )
  }
}

export default LearnPagination
